import { render, staticRenderFns } from "./update.vue?vue&type=template&id=0d4b4e18&scoped=true"
import script from "./update.vue?vue&type=script&lang=ts"
export * from "./update.vue?vue&type=script&lang=ts"
import style0 from "./update.vue?vue&type=style&index=0&id=0d4b4e18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4b4e18",
  null
  
)

export default component.exports